var _rect, _rect2, _path, _rect3, _rect4, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.248,
    y: 18.073,
    className: "st0",
    width: 1.5,
    height: 2.905
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.248,
    y: 3.022,
    className: "st0",
    width: 1.5,
    height: 7.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E__1_",
    className: "st0",
    d: "M8,11.046c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S9.657,11.046,8,11.046z  M8,15.546c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S8.828,15.546,8,15.546z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.251,
    y: 14.045,
    className: "st0",
    width: 1.5,
    height: 6.933
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.251,
    y: 3.022,
    className: "st0",
    width: 1.5,
    height: 3.013
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Path_x3E_",
    className: "st0",
    d: "M16,7.062c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S17.657,7.062,16,7.062z  M16,11.562c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S16.828,11.562,16,11.562z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.af63086b.svg";
export { ForwardRef as ReactComponent };